export const GOOGLE_FAQ_URL = 'https://developers.google.com/fonts/faq'
export const GOOGLE_PRIVACY_URL = 'https://www.google.com/policies/privacy'
